import { BackendUrl, RECAPTCHA_KEY } from "@env";

const Constant = {
    TLYFE_URL:'https://vimeo.com/747992259',
    IMAGE_URL:  "https://assets.openbrix.co.uk/",
    API_URL: BackendUrl || "https://api.openbrix.co.uk/v2.0",
    SERVER_URL: BackendUrl || "https://api.openbrix.co.uk/v2.0",
    OPENFLO_URL:"https://www.youtube.com/watch?v=O18RoDaVYKA&ab_channel=OpenBrixNetwork",
    TDS_CONTACTUS:"https://www.tenancydepositscheme.com/learn-more/information-tds-lounge/contact-us/",
    RECAPTCHA_KEY: RECAPTCHA_KEY || "6LemSK0hAAAAAOpgBpY0oB4ge1-fan6eCXWNYBq2",
    // FORGOT_PASSWORD_UAT:"https://tdsgroupdev.b2clogin.com/tdsgroupdev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_PASSWORDRESET_SEAMLESSMIGRATION_VP&client_id=f6176f65-d8e5-40fe-88ec-c0a9c5dce1e0&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fthedisputeservice--fullcopy.sandbox.my.site.com%2Fnitds1%2Fsign-in&scope=openid&response_type=id_token&prompt=login"
    FORGOT_PASSWORD_UAT:'https://proptech.tenancydepositscheme.com/forgotten-password/'
};

export default Constant;
